const normalizeUrl = (value?: string): string => String(value || '').trim().replace(/\/+$/, '');

const getCurrentHost = (): string => {
  if (typeof window === 'undefined') return 'admin.bassitai.com';
  return String(window.location.host || '').split(':')[0].toLowerCase();
};

const isLocalHost = (host: string): boolean =>
  host === 'localhost' || host === '127.0.0.1' || host.endsWith('.localhost');

const getBaseDomain = (host: string): string => {
  if (!host) return 'bassitai.com';
  if (isLocalHost(host)) return 'localhost';
  const parts = host.split('.').filter(Boolean);
  if (parts.length < 2) return host;
  return parts.slice(-2).join('.');
};

const getProtocol = (): 'http' | 'https' => {
  const host = getCurrentHost();
  return isLocalHost(host) ? 'http' : 'https';
};

const subdomainUrl = (subdomain: string): string => {
  const host = getCurrentHost();
  const baseDomain = getBaseDomain(host);
  if (baseDomain === 'localhost') return `${getProtocol()}://${subdomain}.localhost`;
  return `${getProtocol()}://${subdomain}.${baseDomain}`;
};

export const getApiBaseUrl = (): string => {
  if (typeof window !== 'undefined') {
    const runtime = (window as any).__RUNTIME_CONFIG__ as Record<string, unknown> | undefined;
    const runtimeBase = normalizeUrl(
      String(runtime?.API_BASE_URL || runtime?.apiBaseUrl || runtime?.BASE_URL || '')
    );
    if (runtimeBase) {
      return runtimeBase.endsWith('/api') ? runtimeBase : `${runtimeBase}/api`;
    }
  }
  const envBase = normalizeUrl(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL);
  if (envBase) return envBase.endsWith('/api') ? envBase : `${envBase}/api`;
  return `${subdomainUrl(process.env.REACT_APP_API_SUBDOMAIN || 'api')}/api`;
};

export const getTenantAppUrl = (slug?: string): string => {
  if (slug) {
    const host = getCurrentHost();
    const baseDomain = getBaseDomain(host);
    if (baseDomain === 'localhost') return `${getProtocol()}://${slug}.localhost`;
    return `${getProtocol()}://${slug}.${baseDomain}`;
  }
  const override = normalizeUrl(process.env.REACT_APP_TENANT_APP_URL);
  if (override) return override;
  return subdomainUrl(process.env.REACT_APP_TENANT_SUBDOMAIN || 'app');
};

export const getAdminAppUrl = (): string =>
  normalizeUrl(process.env.REACT_APP_ADMIN_APP_URL) ||
  subdomainUrl(process.env.REACT_APP_ADMIN_SUBDOMAIN || 'admin');

export const getConsoleAppUrl = (): string =>
  normalizeUrl(process.env.REACT_APP_CONSOLE_APP_URL) ||
  subdomainUrl(process.env.REACT_APP_CONSOLE_SUBDOMAIN || 'console');

